module.exports = __webpack_public_path__ + "img/3ddf337949001bfe03bc6684516091ec--pokemon-nintendo-medieval.jpg";